import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchTerm: "",
  transactionType: "",
  order: "",
  limit: 10,
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setTransactionType: (state, action) => {
      state.transactionType = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setOrder: (state, action) => {
      state.order = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    applyAllfilter: (state, action) => {
      state.limit = action.payload.limit;
      state.order = action.payload.order;
      state.transactionType = action.payload.transactionType;
      state.searchTerm = action.payload.setSearchTerm;
    },
    resetAllFilter: () => {
      return initialState;
    },
  },
});

export const filterReducer = filterSlice.reducer;
export const {
  setOrder,
  setSearchTerm,
  setTransactionType,
  setLimit,
  resetAllFilter,
  applyAllfilter,
} = filterSlice.actions;
